import { DEFAULT_FILTER_ID } from './utils';

const initialState = {
  profile: {
    data: null,
    loading: false,
    error: false,
    requestId: null,
    pendingSaves: 0,
  },
  // A null list means it has not been loaded yet (or its request failed).
  editOptions: {
    branches: null,
    teams: null,
    loading: false,
    teamsFailed: false,
  },
  history: {
    userId: null,
    filters: [],
    filterId: DEFAULT_FILTER_ID,
    events: [],
    nextCursor: null,
    loading: false,
    loadingMore: false,
    error: null,
    requestId: null,
  },
  permissions: {
    userId: null,
    panel: null,
    loading: false,
    error: null,
    requestId: null,
    // Saves in flight by change key, with the last value the backend confirmed
    // so a failed save can roll back to it.
    saves: {},
  },
};

export default initialState;
